import {Box, CircularProgress} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {Devices} from '../../../api/api';
import {getDeviceContent} from '../../../state/ducks/devices/operations';
import {localized} from '../../../state/i18n/i18n';
import {AppState} from '../../../state/store';
import JmTitle from '../../components/jm-title/jm-title';
import DeviceManagementContainer from '../../components/device-management/device-management-container/device-management-container';
import './device-management-page.scss';

const mapStateToProps = (state: AppState) => {
  return {
    pendingStatus: state.notificationSettingsReducer.pending,
    devices: state.devicesReducer.devices,
    retrivalStatus: state.notificationSettingsReducer.deviceRetrivalFailed,
    emptyListStatus: state.devicesReducer.receivedEmptyList,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getUserDevices: async (dateFrom: Date = new Date(), dateTo: Date = new Date()) =>
    (await getDeviceContent(dateFrom, dateTo))(dispatch),
});

type Props = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class DeviceManagementPage extends PureComponent<Props> {
  constructor(props: Props) {
    super(props);

    this.props.getUserDevices();
  }

  private dataIsPending = () => {
    if (this.props.pendingStatus === true) {
      return (
        <div className="spinnerSettings">
          <CircularProgress size="4rem" />
        </div>
      );
    }
  };

  private mapUserDevices = () => {
    if (this.props.devices.length > 0) {
      let deviceContainer = this.props.devices.map((device: Devices, index: number) => {
        return <DeviceManagementContainer deviceId={device.deviceId} index={index} key={device.deviceId} />;
      });
      return deviceContainer;
    } else if (this.props.retrivalStatus === false && this.props.emptyListStatus === false) {
      return <div className="emptyMessageSettings">{localized('LoadingDevices')}</div>;
    } else return <div className="emptyMessageSettings">{localized('NoDevices')}</div>;
  };

  public render() {
    return (
      <JmTitle title="Device Management" shouldPrefixBrandName={true}>
        <div className="width scroll deviceManagementPage">
          <div className="headerMainPageContainer">
            <div className="mainPageHeader">{localized('DeviceManagement')}</div>
            <div className="mainPageHeaderSubheader desktop">{this.getHeaderText()}</div>
            <div className="mainPageHeaderSubheader mobile">{this.getHeaderText()}</div>
          </div>
          <Box flexDirection="row" alignItems="flex-start" className="boxPage">
            {this.dataIsPending()}
            {this.mapUserDevices()}
          </Box>
        </div>
      </JmTitle>
    );
  }

  private getHeaderText = () => {
    return (
      <>
        {localized('SetDeviceVariables')}
        <br />
        {localized('WeatherStationText')}:{' '}
        <a
          href="https://confluence.govcloud.dk/pages/viewpage.action?pageId=26476619#Stations(metObs)-StationsavailableforthemetObsservice"
          target="_blank"
          rel="noopener noreferrer">
          {localized('WeatherStations')}
        </a>
      </>
    );
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceManagementPage);
